import React from "react";

const Rating = () => (
    <>
        <img
            src="https://www.rosettastone.com/lp/standard-page-assets/home_assets/2018/device-icons.svg"
            alt="App Device Icon"
            className="app_device_icons"
        />
        <div className="app_rating">
            Rated
            <span className="app_stars">
                <span className="app_stars_hollow">&#9734; &#9734; &#9734; &#9734; &#9734;</span>
                <span className="app_stars_filled">&#9733; &#9733; &#9733; &#9733; &#9733;</span>
            </span>
            in the App Store.
        </div>
    </>
);

export default Rating;
